import * as React from 'react';

import WebNotAvailable from 'components/lexemes/web-not-available';
import { CdnImagePath } from 'lib/cdn-image-path';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

import { FooterContainer } from 'containers/project-love/common/app/footer-container';
import { HeaderContainer } from 'containers/project-love/common/app/header-container';

import { AppQrCode } from 'components/appQrCode/appQrCode';
import PageSectionAboutHero from 'components/page/sections/page-section-about-hero';
import PageSectionCardCarousel from 'components/page/sections/page-section-card-carousel';
import PageSectionCards, {
  PageSectionCardsProps,
} from 'components/page/sections/page-section-cards';
import PageSectionCta from 'components/page/sections/page-section-cta';
import { FormattedText, P1 } from 'components/typography';

const IndexPage: React.FunctionComponent = () => {
  const isMobile = useMediaQuery(MediaQueryWidth['desktop-md']);
  const cards = {
    title: WebNotAvailable.lxWebNotAvailableWhyHeader,
    items: [
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/video-chat/video-chat-use-chat-1.svg`,
        title: WebNotAvailable.lxWebNotAvailableWhyHeader1,
        text: WebNotAvailable.lxWebNotAvailableWhyText1,
        titleTag: 'h3',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/video-chat/video-chat-use-chat-3.svg`,
        title: WebNotAvailable.lxWebNotAvailableWhyHeader2,
        text: WebNotAvailable.lxWebNotAvailableWhyText2,
        titleTag: 'h3',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/video-chat/video-chat-use-chat-2.svg`,
        title: WebNotAvailable.lxWebNotAvailableWhyHeader3,
        text: WebNotAvailable.lxWebNotAvailableWhyText3,
        titleTag: 'h3',
      },
    ] as PageSectionCardsProps['cards'],
  };
  return (
    <>
      <HeaderContainer />
      <main id="main">
        <PageSectionAboutHero
          title={WebNotAvailable.lxWebNotAvailableHeader}
          subtitle={
            <FormattedText>
              <P1 as="p" html={WebNotAvailable.lxWebNotAvailableBody} />
              <P1
                as="p"
                html={`<a href="https://support.bumble.com/hc/articles/30996192802973-An-update-on-Bumble-web"> ${WebNotAvailable.lxWebNotAvailableCta}</a>`}
              />
            </FormattedText>
          }
          color="peach"
        />
        <PageSectionCta
          title={'Get the app'}
          text={
            <FormattedText>
              <P1 as="p" html={WebNotAvailable.lxWebNotAvailableGetTheAppBody} />
              <AppQrCode />
            </FormattedText>
          }
          image={{
            src: `${CdnImagePath}/web-not-available/get-the-app.jpg`,
            objectPosition: '33% 31%',
            inlinePosition: 'start',
          }}
          color="white"
        />

        {isMobile ? (
          <PageSectionCardCarousel title={cards.title} cards={cards.items} />
        ) : (
          <PageSectionCards
            title={cards.title}
            cards={cards.items}
            color="orange"
            styling="filled"
          />
        )}
      </main>
      <FooterContainer />
    </>
  );
};

export default IndexPage;

export { getServerSideProps } from 'lib/get-server-side-props';
